export const findEnumValue = <TValue extends string>(
  values: ReadonlyArray<TValue>,
  candidate: string | null | undefined,
) => values.find((value) => value === candidate) ?? null
